import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { HeadingText } from "../../../shared/ui";

type KybComplianceUpdateLayoutProps = {
  title: string;
  children: React.ReactNode;
};

const KybComplianceUpdateLayout = ({
  title,
  children,
}: KybComplianceUpdateLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-[#F6F7FD]">
      <nav className="sticky top-0 z-40 flex h-20 items-center border-b border-[#E6E9F5] bg-[#F6F7FD] px-6 md:px-8">
        <button
          type="button"
          aria-label="Close update flow"
          onClick={() => navigate("/")}
          className="mr-3 rounded-full p-1 text-[#6F739B] hover:bg-[#EEF1FB]"
        >
          <X size={22} />
        </button>
        <HeadingText className="aku-heading-h5-medium text-[#161827]">
          {title}
        </HeadingText>
      </nav>

      <main className="flex min-h-[calc(100vh-80px)] w-full justify-center px-5 py-14 md:px-12 md:py-20">
        {children}
      </main>
    </div>
  );
};

export default KybComplianceUpdateLayout;
